import React from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Slide,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import activeSaleforceLogo from "../../../Assets/activeSaleforceLogo.svg";
import decisionMakerImage from "../../../Assets/Cloudfigma.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RightSidebarMobile from "../../RightSiderbar/RightSidebarMobile";
import visitLinkImage from "../../../Assets/visit-link.svg";
import Loader from "../../Loader/Loader";

const MFavPeopleInnerTable = ({
  openTableDrawer,
  setOpenTableDrawer,
  innerDataNew,
  pageInner,
  pages,
  loadMore,
  loading,
  isTabPortrait,
  selectedOrganizationData,
  handleRowSelect,
}) => {
  const [openMSidebarDrawer, setOpenMSidebarDrawer] = React.useState("");

  return (
    <>
      {loading ? <Loader /> : null}
      <Slide
        direction="left"
        in={
          openTableDrawer?.id ? openTableDrawer?.id : openTableDrawer?.user?.id
        }
        mountOnEnter
        unmountOnExit
        className="aip-filter-mb-slide-fav-mob"
      >
        <Box
          sx={{
            position: "fixed",
            top: isTabPortrait ? "33px" : "0",
            left: isTabPortrait ? "" : "0",
            width: isTabPortrait ? "calc(100vw - 240px)" : "100vw",
            right: isTabPortrait ? "0px" : "",
            height: "100%",
            bgcolor: "white",
            zIndex: 10,
            boxShadow: 2,
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          <div className="p-2 aip-path-slide-box-people-tab">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              py={1.5}
            >
              <IconButton></IconButton>
              <Typography
                variant="subtitle1"
                fontWeight="bold"
                style={{ textTransform: "capitalize" }}
              >
                {openTableDrawer?.name}
              </Typography>
              <IconButton onClick={() => setOpenTableDrawer()}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <div>
              {innerDataNew?.some((item) => item.people_details) ? (
                innerDataNew
                  ?.slice()
                  ?.sort((a, b) => {
                    if (
                      a.people_details?.decision_maker &&
                      !b.people_details?.decision_maker
                    )
                      return -1;
                    if (
                      !a.people_details?.decision_maker &&
                      b.people_details?.decision_maker
                    )
                      return 1;
                    return (
                      (b.strengthData?.strength || 0) -
                      (a.strengthData?.strength || 0)
                    );
                  })
                  ?.map((row, index) => (
                    <Card
                      key={index}
                      sx={{
                        borderRadius: 3,
                        boxShadow: 2,
                        mb: 2,
                        background: selectedOrganizationData?.some(
                          (i) =>
                            i?.people_details?.person_id ===
                            row?.people_details?.person_id,
                        )
                          ? "#c0dae6"
                          : "#fff",
                      }}
                    >
                      <CardContent>
                        <Grid container alignItems="center" spacing={0.5}>
                          <Grid item>
                            <div
                              className={
                                row?.people_details?.decision_maker === true
                                  ? "Decision-maker-user-name"
                                  : "Decision-maker-user-noborder create-name-img"
                              }
                            >
                              <img
                                className={
                                  row?.people_details?.suspect_status === null
                                    ? "hide-image"
                                    : row?.people_details?.journey_status ===
                                        "project created"
                                      ? "decisionMakerImageAi-Decisionmaker-green"
                                      : "decisionMakerImageAi-Decisionmaker"
                                }
                                src={
                                  row?.people_details?.journey_status ===
                                  "project created"
                                    ? activeSaleforceLogo
                                    : decisionMakerImage
                                }
                                alt=""
                              />
                              <p className="letter-heading">
                                {row?.people_details?.first_name
                                  ? row?.people_details?.first_name
                                      ?.split(" ")
                                      ?.find((item) => !item.includes("("))
                                      ?.charAt(0)
                                  : ""}
                                {row?.people_details?.last_name
                                  ? row?.people_details?.last_name
                                      ?.split(" ")
                                      ?.find((item) => !item.includes("("))
                                      ?.charAt(0)
                                  : ""}
                              </p>
                            </div>
                          </Grid>
                          <Grid item xs>
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              style={{ textTransform: "capitalize" }}
                              onClick={() => handleRowSelect(row)}
                            >
                              {row?.people_details?.first_name === "jp"
                                ? "JP"
                                : row?.people_details?.first_name || "---"}
                              &nbsp;
                              {row?.people_details?.last_name
                                ? row?.people_details?.last_name
                                : "---"}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              <div className="job-title-container">
                                <div className="tooltip-container-jobtitle">
                                  <p
                                    className={
                                      row?.people_details?.raw_job_title
                                        ? "tooltip-highlights-jobtitle"
                                        : "tooltip-highlights-jobtitle-none"
                                    }
                                  >
                                    {row?.people_details?.raw_job_title}
                                  </p>
                                  <p className="after-company-name-country-fordecisionmaker">
                                    {row?.people_details?.primary_job_title
                                      ? row.people_details.primary_job_title.substring(
                                          0,
                                          18,
                                        ) +
                                        (row.people_details.primary_job_title
                                          .length > 18
                                          ? "..."
                                          : "")
                                      : "---"}
                                  </p>
                                </div>
                              </div>
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Box display="flex" alignItems="center" gap={1}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                  bgcolor: "#f5f6f8",
                                  borderRadius: "50px",
                                  px: 1.2,
                                  py: 0.3,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  fontWeight={500}
                                  color="text.primary"
                                >
                                  {row?.strengthData?.strength
                                    ? row?.strengthData?.strength
                                    : "---"}
                                </Typography>
                              </Box>
                              {row?.strengthData?.strength === 0 ||
                              row?.strengthData?.strength === "---" ? (
                                <IconButton
                                  size="small"
                                  sx={{
                                    bgcolor: "hsl(220deg 4.04% 64.98%)",
                                    "&:hover": {
                                      bgcolor: "hsl(220deg 4.04% 64.98%)",
                                    },
                                  }}
                                >
                                  <ArrowForwardIosIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                  />
                                </IconButton>
                              ) : (
                                <IconButton
                                  size="small"
                                  sx={{
                                    bgcolor: "#f5f6f8",
                                    "&:hover": { bgcolor: "#eaeaea" },
                                  }}
                                >
                                  <ArrowForwardIosIcon
                                    fontSize="small"
                                    sx={{ color: "red" }}
                                    onClick={() => {
                                      setOpenMSidebarDrawer(row);
                                      window.scrollTo(0, 0);
                                    }}
                                  />
                                </IconButton>
                              )}
                            </Box>
                          </Grid>
                        </Grid>

                        <Box mt={2}>
                          <Grid container spacing={1}>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Organization
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ textTransform: "capitalize" }}
                              >
                                {row.people_details?.primary_organization
                                  ? row.people_details.primary_organization
                                  : "---"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Industry
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ textTransform: "capitalize" }}
                              >
                                {row?.people_details?.categories || "---"}
                              </Typography>
                            </Grid>

                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                JOSF Status
                              </Typography>
                              <Typography variant="body2">
                                {" "}
                                {row?.people_details?.suspect_status
                                  ? row.people_details.suspect_status
                                  : "---"}
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                Contact Details
                              </Typography>

                              <Typography
                                variant="body2"
                                style={{
                                  display: "flex",
                                  gap: "5px",
                                  alignItems: "center",
                                }}
                              >
                                {row?.people_details?.linkedin
                                  ? row.people_details.linkedin.length > 28
                                    ? row.people_details.linkedin.substr(28, 22)
                                    : row.people_details.linkedin
                                  : "---"}

                                {row?.people_details?.linkedin && (
                                  <span
                                    onClick={() =>
                                      window.open(row.people_details.linkedin)
                                    }
                                  >
                                    <img src={visitLinkImage} alt="" />
                                  </span>
                                )}
                              </Typography>

                              <Typography variant="body2">
                                {row?.people_details?.email
                                  ? row.people_details.email.length > 18
                                    ? row.people_details.email.substr(0, 18) +
                                      "..."
                                    : row.people_details.email
                                  : "---"}
                              </Typography>

                              <Typography variant="body2">
                                {row?.people_details?.phone_no
                                  ? row.people_details.phone_no.length > 22
                                    ? row.people_details.phone_no.substr(
                                        0,
                                        22,
                                      ) + "..."
                                    : row.people_details.phone_no
                                  : "---"}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </CardContent>
                    </Card>
                  ))
              ) : (
                <Box textAlign="center" py={4}>
                  <Typography variant="body1" color="text.secondary">
                    No records found
                  </Typography>
                </Box>
              )}
              <RightSidebarMobile
                openSidebar={openMSidebarDrawer}
                setOpenSidebar={setOpenMSidebarDrawer}
              />
              {innerDataNew?.length >= 20 ? (
                <div className="loadmore-pagination-section">
                  {pageInner <= Math.ceil(pages) && (
                    <button
                      className="btn-load-more button-loadmore-pagination"
                      onClick={loadMore}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </button>
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </Box>
      </Slide>
    </>
  );
};
export default MFavPeopleInnerTable;
